import { render, staticRenderFns } from "./carForm.vue?vue&type=template&id=107009a6&scoped=true&"
import script from "./carForm.vue?vue&type=script&lang=js&"
export * from "./carForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107009a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107009a6')) {
      api.createRecord('107009a6', component.options)
    } else {
      api.reload('107009a6', component.options)
    }
    module.hot.accept("./carForm.vue?vue&type=template&id=107009a6&scoped=true&", function () {
      api.rerender('107009a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/carForm.vue"
export default component.exports